export default [
  {id: 1, codigo: 'ARROBA', label: 'Arroba', listagem: 'arroba(s)', tipo: 'QUANTIDADE'},
  {id: 2, codigo: 'CACHOS', label: 'Cachos', listagem: 'cacho(s)', tipo: 'QUANTIDADE'},
  {id: 3, codigo: 'CENTOS_FRUTOS', label: 'Centos de Frutos', listagem: 'cento(s) de frutos', tipo: 'QUANTIDADE'},
  {id: 4, codigo: 'METROS_CUBICOS', label: 'Metros Cúbicos (m³)', listagem: 'm³', tipo: 'QUANTIDADE'},
  {id: 5, codigo: 'QUILO', label: 'Quilo (Kg)', listagem: 'kg', tipo: 'QUANTIDADE'},
  {id: 6, codigo: 'SACO_50KG', label: 'Saco de 50 Kg', listagem: 'saco(s) de 50 kg', tipo: 'QUANTIDADE'},
  {id: 7, codigo: 'SACO_60KG', label: 'Saco de 60 Kg', listagem: 'saco(s) de 60 kg', tipo: 'QUANTIDADE'},
  {id: 8, codigo: 'TONELADA', label: 'Tonelada', listagem: 'tonelada(s)', tipo: 'QUANTIDADE'},
  {id: 9, codigo: 'METROS', label: 'Metros (m)', listagem: 'm', tipo: 'AREA'},
  {id: 10, codigo: 'METROS_QUADRADOS', label: 'Metros Quadrados (m²)', listagem: 'm²', tipo: 'AREA'},
  {id: 11, codigo: 'METROS_CUBICOS', label: 'Metros Cúbicos (m³)', listagem: 'm³', tipo: 'AREA'},
  {id: 12, codigo: 'QUILOMETROS', label: 'Quilômetro (km)', listagem: 'km', tipo: 'AREA'}
]



// WEBPACK FOOTER //
// ./src/utils/tipoUnidadesMedidasEdificacao.js